'use client';

import * as React from 'react';
import { useSearchParams } from 'next/navigation';
import { MethodResponse } from '@alien-platform/bo-sdk-v2';
import { Button, Stack } from '@mui/material';
import { toast } from 'sonner';

import { RowProps } from '@/types/general';
import { DynamicTable } from '@/components/core/reusable-table-v3';

import { getGamesJurisdictionsTableData } from '../helpers/games-jurisdictions-table-data';
import { gamesJurisdictionsTableHeaders } from '../helpers/games-jurisdictions-table-headers';

export function GameJurisdictionsTable({ gameData }: { gameData: any }): React.JSX.Element | null {
  const [isLoading, setIsLoading] = React.useState(false);
  const [jurisdictionsSettings, setJurisdictionsSettings] = React.useState<any[]>([]);

  const searchParams = useSearchParams();
  const opId = searchParams.get('opId');

  const getJurisdictions = async (): Promise<void> => {
    try {
      const res = await fetch('/api/games/jurisdictions', {
        method: 'POST',
        body: JSON.stringify({
          gameId: gameData.gameId,
        }),
      });
      const result: MethodResponse<any[]> = await res.json();
      if (res.ok && result.success && result.data) {
        setJurisdictionsSettings(result.data);
      }
    } catch (e) {
      // noob
    }
  };

  React.useEffect(() => {
    void getJurisdictions();
  }, []);

  const tableData: RowProps[] = getGamesJurisdictionsTableData({
    gameData: jurisdictionsSettings,
    setGameData: setJurisdictionsSettings,
  });

  const handleSave = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const res = await fetch(`/api/games/jurisdictions?opId=${opId}&gameId=${gameData.gameId}`, {
        method: 'PUT',
        body: JSON.stringify(jurisdictionsSettings),
      });
      const result = await res.json();
      if (res.ok && result.success) {
        toast.success('Game settings have been updated successfully!');
      } else {
        toast.error('Error:500 | Unable to update game settings!');
      }
    } catch (e) {
      //noob
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack>
      <DynamicTable headers={gamesJurisdictionsTableHeaders} rows={tableData} />
      <Stack direction="row" justifyContent="end" gap={2}>
        <Button loading={isLoading} variant="contained" onClick={handleSave}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
}
